import { projectClient } from '../../client/client';

export const rcm = {
  eligibilityCheck: projectClient('/rcm/eligibility-check').post,
  submitProfessionalClaim: projectClient('/rcm/professional-claim/submit').post,
  validateProfessionalClaim: projectClient('/rcm/professional-claim/validate').post,
};
